import cx from 'classnames';
import { useFormControlContext } from './useFormControl';
import { forwardRef, DetailedHTMLProps, InputHTMLAttributes } from 'react';

export interface IFormControlInputProps
  extends Omit<DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'ref' | 'size'> {
  variant?: 'default' | 'rio';
  size?: 'small' | 'medium';
}

export const FormControlInput = forwardRef((props: IFormControlInputProps, ref: any) => {
  const { className, disabled, variant, size, value, ...restProps } = props;

  const { readOnly } = useFormControlContext() || {};

  return (
    <input
      ref={ref}
      disabled={disabled || readOnly}
      className={cx(
        'slds-input',
        {
          'rio-input': variant === 'rio'
        },
        {
          'rio-input--small': size === 'small'
        },
        className
      )}
      style={readOnly ? { backgroundColor: '#aaa' } : {}}
      value={typeof value !== 'undefined' ? value || '' : undefined}
      {...restProps}
    />
  );
});

FormControlInput.displayName = 'FormControlInput';
